import React, { useState, useEffect } from 'react';
import { useSiteSettings } from '../hooks/useSiteSettings';
import axios from 'axios';

function LeadsKanban() {
  const brand = useSiteSettings();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLead, setSelectedLead] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showAiPanel, setShowAiPanel] = useState(false);
  const [aiTargetLead, setAiTargetLead] = useState(null);
  const [aiAnalysisResult, setAiAnalysisResult] = useState(null);
  const [isScoring, setIsScoring] = useState(false);

  const [newLead, setNewLead] = useState({
    name: '',
    phone: '',
    email: '',
    value: '',
    notes: '',
    stage: 'new',
    country: 'TR',
    procedure: '',
    channel: 'WhatsApp',
    score: 50
  });

  const columns = [
    { id: 'new', title: 'YENİ', color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.1)', badgeColor: '#94a3b8' },
    { id: 'qualifying', title: 'AI UYGUNLUK', color: '#60a5fa', bg: 'rgba(59, 130, 246, 0.1)', badgeColor: '#60a5fa' },
    { id: 'hot', title: '🔥 SICAK FIRSAT', color: '#f87171', bg: 'rgba(239, 68, 68, 0.1)', badgeColor: '#f87171' },
    { id: 'nurturing', title: '⏳ BESLEME & TAKİP', color: '#fbbf24', bg: 'rgba(245, 158, 11, 0.1)', badgeColor: '#fbbf24' },
    { id: 'appointment', title: '📅 RANDEVU', color: '#a78bfa', bg: 'rgba(139, 92, 246, 0.1)', badgeColor: '#a78bfa' }
  ];

  // Prepopulated mock data exactly matching the user's screenshot
  const initialMockLeads = [];

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    try {
      const token = localStorage.getItem('crm_token');
      const response = await axios.get('/api/callops/leads', {
        headers: { Authorization: `Bearer ${token}` }
      }).catch(() => {
        return { data: [] };
      });

      const rawLeads = Array.isArray(response.data) ? response.data : (response.data.leads || []);
      const mapped = rawLeads.map((l) => ({
        ...l,
        stage: l.stage || 'new',
        country: l.country || 'TR',
        procedure: l.procedure || l.notes || 'Genel Görüşme',
        value: l.value ?? 0,
        score: l.score ?? 50,
        channel: l.channel || 'WhatsApp',
        date: l.date || (l.created_at ? l.created_at.split('T')[0] : new Date().toISOString().split('T')[0])
      }));
      setLeads(mapped);
    } catch (err) {
      console.error(err);
      setLeads([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDragStart = (e, id) => {
    e.dataTransfer.setData('leadId', id);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = async (e, targetStage) => {
    const leadId = parseInt(e.dataTransfer.getData('leadId'));
    const previousLeads = leads;
    const updatedLeads = leads.map(l => l.id === leadId ? { ...l, stage: targetStage } : l);
    setLeads(updatedLeads);

    try {
      const token = localStorage.getItem('crm_token');
      await axios.put(`/api/callops/leads/${leadId}`, { stage: targetStage }, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (err) {
      console.error('Stage update failed, reverting:', err);
      setLeads(previousLeads);
    }
  };

  const handleAddLead = async (e) => {
    e.preventDefault();
    const payload = {
      ...newLead,
      sector: newLead.procedure,
      value: parseFloat(newLead.value) || 0
    };

    try {
      const token = localStorage.getItem('crm_token');
      const response = await axios.post('/api/callops/leads', payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const leadToAdd = {
        ...payload,
        id: response.data.id,
        date: new Date().toISOString().split('T')[0]
      };
      setLeads(prev => [...prev, leadToAdd]);
      setShowAddModal(false);
      setNewLead({
        name: '', phone: '', email: '', value: '', notes: '', stage: 'new',
        country: 'TR', procedure: '', channel: 'WhatsApp', score: 50
      });
    } catch (err) {
      console.error('Lead oluşturulamadı:', err);
      alert('Fırsat oluşturulamadı, lütfen tekrar deneyin.');
    }
  };

  const generateAiLeads = (sector) => {
    let mockBatch = [];
    if (sector === 'beauty_salon') {
      mockBatch = [
        { id: Date.now() + 1, name: 'Meltem H.', country: 'TR', procedure: 'Dolgu & Hydrafacial', score: 65, channel: 'WhatsApp', stage: 'new', phone: '+90 532 999 8888', value: 8500, notes: 'Kırışıklık tedavisi paketi talep etti.' },
        { id: Date.now() + 2, name: 'Didem Y.', country: 'TR', procedure: 'Microblading', score: 72, channel: 'WhatsApp', stage: 'qualifying', phone: '+90 533 888 7777', value: 5000, notes: 'Önceki işlemlerinin silinmesini istiyor.' }
      ];
    } else if (sector === 'health_tourism') {
      mockBatch = [
        { id: Date.now() + 1, name: 'John D.', country: 'GB', procedure: 'Dental Implant', score: 85, channel: 'WhatsApp', stage: 'new', phone: '+44 7700 900077', value: 120000, notes: 'All-on-4 implant tedavisi fiyatı sordu.' },
        { id: Date.now() + 2, name: 'Amelie R.', country: 'DE', procedure: 'Hair Transplant', score: 90, channel: 'Voice', stage: 'hot', phone: '+49 170 9876543', value: 65000, notes: 'Temmuz ayı için rezervasyon planlıyor.' }
      ];
    } else if (sector === 'bridal_shop') {
      mockBatch = [
        { id: Date.now() + 1, name: 'Zeynep T.', country: 'TR', procedure: 'A-Kesim Gelinlik', score: 78, channel: 'WhatsApp', stage: 'new', phone: '+90 555 123 9988', value: 35000, notes: 'Özel tasarım saten kumaş istiyor.' },
        { id: Date.now() + 2, name: 'Buse K.', country: 'TR', procedure: 'Dantelli Nişanlık', score: 50, channel: 'WhatsApp', stage: 'nurturing', phone: '+90 530 456 7890', value: 18000, notes: 'Renk kartelası örneklerini bekliyor.' }
      ];
    } else if (sector === 'dental_clinic') {
      mockBatch = [
        { id: Date.now() + 1, name: 'Serkan O.', country: 'TR', procedure: 'Zirkonyum Kaplama', score: 80, channel: 'WhatsApp', stage: 'new', phone: '+90 541 222 3344', value: 92000, notes: 'Gülüş tasarımı analizi istedi.' },
        { id: Date.now() + 2, name: 'Hale Ş.', country: 'TR', procedure: 'Diş Beyazlatma', score: 35, channel: 'Voice', stage: 'new', phone: '+90 539 888 7766', value: 6000, notes: 'Fiyat listesi SMS ile iletildi.' }
      ];
    } else {
      mockBatch = [
        { id: Date.now() + 1, name: 'Fatih A.', country: 'TR', procedure: 'Yıllık Bakım Üyeliği', score: 60, channel: 'WhatsApp', stage: 'new', phone: '+90 507 111 2233', value: 15000, notes: 'Paket detayları e-posta ile gönderildi.' }
      ];
    }

    const updated = [...leads, ...mockBatch];
    setLeads(updated);
    setAiAnalysisResult(null);
    setShowAiPanel(false);
  };

  const runAiScoring = () => {
    if (!aiTargetLead) return;
    setIsScoring(true);
    setAiAnalysisResult(null);

    // Simulate AI model processing time and recommendation logic
    setTimeout(() => {
      let finalScore = Math.floor(Math.random() * 30); // Base variation
      let rec = '';
      let nextAction = '';

      if (aiTargetLead.notes && aiTargetLead.notes.toLowerCase().includes('istiyor')) {
        finalScore += 65;
        rec = 'Müşteri satın alma aşamasına son derece yakın. Hemen iletişime geçip kapora ödemesini alın.';
        nextAction = '📅 Yarın saat 11:00 için görüntülü görüşme veya randevu saati teyit edin.';
      } else if (aiTargetLead.value > 50000) {
        finalScore += 55;
        rec = 'Yüksek değerli VIP fırsat. Özel bir indirim veya esnek ödeme planı sunarak anlaşmayı netleştirin.';
        nextAction = '📞 Satış yöneticisi kanalıyla telefon araması gerçekleştirin.';
      } else {
        finalScore += 40;
        rec = 'İlgi düzeyi orta seviyede. Kampanyalı paket ve başarı hikayelerimizin linkini WhatsApp üzerinden paylaşın.';
        nextAction = '💬 WhatsApp üzerinden referans çalışma fotoğrafları gönderin.';
      }

      if (finalScore > 100) finalScore = 100;
      if (finalScore < 10) finalScore = 15;

      setAiAnalysisResult({
        score: finalScore,
        recommendation: rec,
        nextStep: nextAction
      });

      // Update lead score globally in the board list
      setLeads(prev => prev.map(l => l.id === aiTargetLead.id ? { ...l, score: finalScore } : l));
      setIsScoring(false);
    }, 1200);
  };

  const getScoreRange = (score) => {
    if (score < 40) return 'low';
    if (score < 75) return 'medium';
    return 'high';
  };

  const filteredLeads = leads.filter(l => 
    l.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (l.phone && l.phone.includes(searchTerm)) ||
    (l.procedure && l.procedure.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div className="kanban-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Lead Pipeline</h1>
          <p className="page-subtitle">Hasta ve müşteri adaylarınızı satış hunisinde yapay zeka skorlarıyla takip edin</p>
        </div>
        <div className="header-actions">
          <input 
            type="text" 
            placeholder="Fırsat veya işlem ara..." 
            className="input search-input" 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="btn btn-primary" onClick={() => setShowAddModal(true)}>
            + Yeni Fırsat Ekle
          </button>
        </div>
      </div>

      <div className="kanban-board">
        {columns.map(col => {
          const colLeads = filteredLeads.filter(l => l.stage === col.id);

          return (
            <div 
              key={col.id} 
              className="kanban-column"
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, col.id)}
              style={{ '--col-color': col.color, '--col-bg': col.bg }}
            >
              <div className="column-header" style={{ background: col.bg, border: '1px solid rgba(255,255,255,0.03)', borderRadius: '10px', padding: '10px 14px' }}>
                <div className="column-title-group">
                  <span className="column-dot" style={{ background: col.color, boxShadow: `0 0 8px ${col.color}` }}></span>
                  <h3 className="column-title" style={{ fontSize: '13px', fontWeight: 800 }}>{col.title}</h3>
                  <span className="column-count" style={{ background: 'rgba(255,255,255,0.08)', color: '#fff', marginLeft: '4px' }}>{colLeads.length}</span>
                </div>
              </div>

              <div className="column-body">
                {colLeads.length === 0 ? (
                  <div className="column-empty">Fırsat yok</div>
                ) : (
                  colLeads.map(lead => (
                    <div 
                      key={lead.id} 
                      className="kanban-card" 
                      draggable 
                      onDragStart={(e) => handleDragStart(e, lead.id)}
                      onClick={() => setSelectedLead(lead)}
                    >
                      <div className="card-header-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span className="country-badge">{lead.country || 'TR'}</span>
                          <h4 className="card-name" style={{ margin: 0, fontSize: '13px', fontWeight: 700, color: '#fff' }}>{lead.name}</h4>
                        </div>
                      </div>
                      
                      <div className="card-procedure" style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginBottom: '12px' }}>
                        {lead.procedure || 'Fırsat Detayı'}
                      </div>

                      <div className="card-footer-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className={`score-badge score-${getScoreRange(lead.score)}`}>
                          {lead.score || 0}
                        </div>
                        {lead.channel && (
                          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {lead.channel === 'WhatsApp' ? '💬 WhatsApp' : '📞 Voice'}
                          </span>
                        )}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Selected Lead Detail Modal */}
      {selectedLead && (
        <div className="modal-overlay" onClick={() => setSelectedLead(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Fırsat Detayı</h3>
              <button className="modal-close" onClick={() => setSelectedLead(null)}>×</button>
            </div>
            <div className="modal-body">
              <div className="detail-item">
                <strong>Müşteri Adı:</strong>
                <span>{selectedLead.name}</span>
              </div>
              <div className="detail-item">
                <strong>Ülke:</strong>
                <span className="badge badge-gray">{selectedLead.country}</span>
              </div>
              <div className="detail-item">
                <strong>Telefon:</strong>
                <span>{selectedLead.phone}</span>
              </div>
              <div className="detail-item">
                <strong>E-posta:</strong>
                <span>{selectedLead.email || '-'}</span>
              </div>
              <div className="detail-item">
                <strong>Talep / Hizmet:</strong>
                <span>{selectedLead.procedure}</span>
              </div>
              <div className="detail-item">
                <strong>Kanal:</strong>
                <span>{selectedLead.channel}</span>
              </div>
              <div className="detail-item">
                <strong>AI Skor:</strong>
                <span className={`badge score-${getScoreRange(selectedLead.score)}`} style={{ padding: '4px 10px' }}>
                  {selectedLead.score} / 100
                </span>
              </div>
              <div className="detail-item">
                <strong>Tahmini Değer:</strong>
                <span>{(selectedLead.value || 0).toLocaleString('tr-TR')} ₺</span>
              </div>
              <div className="detail-item">
                <strong>Aşama:</strong>
                <span className="badge" style={{ background: columns.find(c => c.id === selectedLead.stage)?.color + '20', color: columns.find(c => c.id === selectedLead.stage)?.color }}>
                  {columns.find(c => c.id === selectedLead.stage)?.title}
                </span>
              </div>
              <div className="detail-item full-width">
                <strong>Notlar:</strong>
                <p className="detail-notes">{selectedLead.notes || 'Not eklenmemiş.'}</p>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setSelectedLead(null)} style={{ width: '100%' }}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      {/* Add Lead Modal */}
      {showAddModal && (
        <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Yeni Fırsat Ekle</h3>
              <button className="modal-close" onClick={() => setShowAddModal(false)}>×</button>
            </div>
            <form onSubmit={handleAddLead}>
              <div className="modal-body">
                <div className="form-group">
                  <label className="form-label">Müşteri Adı Soyadı</label>
                  <input 
                    type="text" 
                    className="input" 
                    required 
                    value={newLead.name}
                    onChange={e => setNewLead({ ...newLead, name: e.target.value })}
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px' }}>
                  <div className="form-group">
                    <label className="form-label">Ülke Kodu</label>
                    <input 
                      type="text" 
                      className="input" 
                      placeholder="e.g. TR, SA"
                      value={newLead.country}
                      onChange={e => setNewLead({ ...newLead, country: e.target.value.toUpperCase() })}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Telefon</label>
                    <input 
                      type="text" 
                      className="input" 
                      required 
                      value={newLead.phone}
                      onChange={e => setNewLead({ ...newLead, phone: e.target.value })}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">E-posta</label>
                  <input 
                    type="email" 
                    className="input" 
                    value={newLead.email}
                    onChange={e => setNewLead({ ...newLead, email: e.target.value })}
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Talep Edilen Hizmet</label>
                  <input 
                    type="text" 
                    className="input" 
                    placeholder="e.g. Lazer Epilasyon"
                    value={newLead.procedure}
                    onChange={e => setNewLead({ ...newLead, procedure: e.target.value })}
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                  <div className="form-group">
                    <label className="form-label">Kanal</label>
                    <select 
                      className="select" 
                      value={newLead.channel}
                      onChange={e => setNewLead({ ...newLead, channel: e.target.value })}
                    >
                      <option value="WhatsApp">WhatsApp</option>
                      <option value="Voice">Voice</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Tahmini Değer (₺)</label>
                    <input 
                      type="number" 
                      className="input" 
                      value={newLead.value}
                      onChange={e => setNewLead({ ...newLead, value: e.target.value })}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label className="form-label">Aşama</label>
                  <select 
                    className="select" 
                    value={newLead.stage}
                    onChange={e => setNewLead({ ...newLead, stage: e.target.value })}
                  >
                    {columns.map(c => <option key={c.id} value={c.id}>{c.title}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Özel Notlar</label>
                  <textarea 
                    className="input" 
                    rows="2" 
                    value={newLead.notes}
                    onChange={e => setNewLead({ ...newLead, notes: e.target.value })}
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>Fırsatı Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Floating AI Panel Button */}
      <button 
        className="ai-floating-btn" 
        onClick={() => setShowAiPanel(true)}
        title="AI ile Fırsat Analiz Et & Üret"
      >
        🤖
      </button>

      {/* AI Assistant Side Drawer */}
      {showAiPanel && (
        <div className="ai-drawer-overlay" onClick={() => setShowAiPanel(false)}>
          <div className="ai-drawer" onClick={e => e.stopPropagation()}>
            <div className="ai-drawer-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '20px' }}>🤖</span>
                <h3 className="ai-drawer-title">{brand.assistant_name || 'AI Asistanı'}</h3>
              </div>
              <button className="modal-close" onClick={() => setShowAiPanel(false)}>×</button>
            </div>
            
            <div className="ai-drawer-body">
              <div className="ai-section">
                <h4 className="ai-section-title">✨ AI Fırsat Jeneratörü <span className="badge" style={{ background: 'rgba(148,163,184,0.2)', color: '#94a3b8', fontSize: '10px', verticalAlign: 'middle' }}>DEMO</span></h4>
                <p className="ai-section-desc">Mevcut sektöre uygun örnek (demo amaçlı, gerçek veri değil) fırsatlar üretir. Bu fırsatlar kaydedilmez, sayfa yenilenince kaybolur.</p>
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>
                  <button className="btn btn-secondary btn-sm" onClick={() => generateAiLeads('beauty_salon')}>Güzellik</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => generateAiLeads('health_tourism')}>Sağlık</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => generateAiLeads('bridal_shop')}>Gelinlik</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => generateAiLeads('dental_clinic')}>Diş Kliniği</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => generateAiLeads('general')}>Genel</button>
                </div>
              </div>

              <div className="ai-section" style={{ marginTop: '24px' }}>
                <h4 className="ai-section-title">🔍 AI Skorlama & Öneri <span className="badge" style={{ background: 'rgba(148,163,184,0.2)', color: '#94a3b8', fontSize: '10px', verticalAlign: 'middle' }}>DEMO</span></h4>
                <p className="ai-section-desc">Huni üzerindeki bir fırsatı seçin — bu, gerçek bir AI çağrısı değil, örnek bir simülasyondur ve skor kalıcı olarak kaydedilmez.</p>
                
                <select 
                  className="select" 
                  style={{ marginTop: '12px' }}
                  onChange={(e) => {
                    const leadId = parseInt(e.target.value);
                    const selected = leads.find(l => l.id === leadId);
                    setAiTargetLead(selected);
                    setAiAnalysisResult(null);
                  }}
                  value={aiTargetLead ? aiTargetLead.id : ''}
                >
                  <option value="">-- Fırsat Seçin --</option>
                  {leads.map(l => (
                    <option key={l.id} value={l.id}>{l.name} - {l.procedure || 'Genel'}</option>
                  ))}
                </select>

                {aiTargetLead && (
                  <button 
                    className="btn btn-primary" 
                    style={{ width: '100%', marginTop: '12px', height: '36px' }}
                    onClick={runAiScoring}
                    disabled={isScoring}
                  >
                    {isScoring ? 'Analiz Ediliyor...' : 'Yapay Zekayı Çalıştır'}
                  </button>
                )}

                {aiAnalysisResult && (
                  <div className="ai-result-card" style={{ marginTop: '16px', background: 'rgba(var(--primary-rgb), 0.05)', border: '1px solid rgba(var(--primary-rgb), 0.2)', padding: '16px', borderRadius: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontWeight: 600, color: '#fff' }}>Dönüşüm Skoru:</span>
                      <span className="badge" style={{ backgroundColor: aiAnalysisResult.score >= 70 ? 'rgba(16, 185, 129, 0.2)' : 'rgba(251, 191, 36, 0.2)', color: aiAnalysisResult.score >= 70 ? '#10b981' : '#fbbf24', fontSize: '14px', padding: '4px 10px', border: 'none' }}>
                        {aiAnalysisResult.score} / 100
                      </span>
                    </div>
                    <div style={{ marginTop: '12px', fontSize: '13px', color: 'rgba(255,255,255,0.7)', lineHeight: '1.5' }}>
                      <strong>AI Önerisi:</strong> {aiAnalysisResult.recommendation}
                    </div>
                    <div style={{ marginTop: '10px' }}>
                      <strong style={{ fontSize: '12px', color: 'var(--primary)' }}>Sıradaki Eylem:</strong>
                      <div style={{ fontSize: '13px', color: '#fff', marginTop: '4px' }}>{aiAnalysisResult.nextStep}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .kanban-page {
          padding: 10px 0;
          position: relative;
        }
        
        .search-input {
          max-width: 250px;
          margin-right: 12px;
        }

        .kanban-board {
          display: grid;
          grid-template-columns: repeat(5, minmax(220px, 1fr));
          gap: 16px;
          margin-top: 24px;
          min-height: calc(100vh - 220px);
          overflow-x: auto;
          padding-bottom: 20px;
          align-items: start;
        }

        .kanban-column {
          background: rgba(255, 255, 255, 0.02);
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 16px;
          padding: 16px;
          min-height: 550px;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        .kanban-column:hover {
          border-color: var(--col-color);
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.4), 0 0 10px var(--col-bg);
        }

        .column-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        }

        .column-title-group {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .column-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }

        .column-title {
          font-size: 13px;
          font-weight: 800;
          color: #ffffff;
        }

        .column-count {
          font-size: 11px;
          padding: 2px 6px;
          border-radius: 99px;
          font-weight: 700;
        }

        .column-body {
          display: flex;
          flex-direction: column;
          gap: 12px;
          flex: 1;
        }

        .column-empty {
          text-align: center;
          padding: 30px 10px;
          color: rgba(255, 255, 255, 0.25);
          font-size: 13px;
          border: 2px dashed rgba(255, 255, 255, 0.04);
          border-radius: 12px;
        }

        .kanban-card {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.05);
          border-radius: 12px;
          padding: 14px;
          cursor: grab;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .kanban-card:active {
          cursor: grabbing;
        }

        .kanban-card:hover {
          background: rgba(255, 255, 255, 0.06);
          border-color: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
        }

        .country-badge {
          font-size: 10px;
          background: rgba(255, 255, 255, 0.08);
          padding: 2px 5px;
          border-radius: 4px;
          color: rgba(255, 255, 255, 0.7);
          font-weight: 700;
        }

        .score-badge {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 11px;
          font-weight: 700;
          color: #fff;
        }

        .score-low {
          background: rgba(148, 163, 184, 0.15);
          border: 1px solid rgba(148, 163, 184, 0.35);
          color: #94a3b8;
        }

        .score-medium {
          background: rgba(245, 158, 11, 0.15);
          border: 1px solid rgba(245, 158, 11, 0.35);
          color: #fbbf24;
        }

        .score-high {
          background: rgba(239, 68, 68, 0.15);
          border: 1px solid rgba(239, 68, 68, 0.35);
          color: #f87171;
        }

        .detail-item {
          display: flex;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          font-size: 14px;
        }

        .detail-item strong {
          color: rgba(255, 255, 255, 0.6);
        }

        .detail-item span {
          color: #ffffff;
          font-weight: 500;
        }

        .detail-item.full-width {
          flex-direction: column;
          border-bottom: none;
          gap: 8px;
        }

        .detail-notes {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.05);
          padding: 12px;
          border-radius: 10px;
          font-size: 13px;
          color: rgba(255, 255, 255, 0.85);
          line-height: 1.5;
        }

        /* AI Floating button */
        .ai-floating-btn {
          position: fixed;
          bottom: 30px;
          right: 30px;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: linear-gradient(135deg, var(--primary), var(--secondary));
          border: none;
          color: white;
          font-size: 24px;
          cursor: pointer;
          box-shadow: 0 8px 32px rgba(var(--primary-rgb), 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99;
          transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }

        .ai-floating-btn:hover {
          transform: scale(1.1) rotate(10deg);
          box-shadow: 0 12px 40px rgba(var(--primary-rgb), 0.6);
        }

        /* AI Drawer Side Panel */
        .ai-drawer-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(8px);
          z-index: 1000;
          display: flex;
          justify-content: flex-end;
          animation: fadeIn 0.2s ease;
        }

        .ai-drawer {
          width: 100%;
          max-width: 400px;
          height: 100%;
          background: rgba(12, 15, 25, 0.95);
          border-left: 1px solid rgba(255, 255, 255, 0.08);
          box-shadow: -10px 0 40px rgba(0,0,0,0.5);
          display: flex;
          flex-direction: column;
          animation: slideLeft 0.3s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .ai-drawer-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        }

        .ai-drawer-title {
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          margin: 0;
        }

        .ai-drawer-body {
          padding: 20px;
          overflow-y: auto;
          flex: 1;
        }

        .ai-section {
          background: rgba(255, 255, 255, 0.02);
          border: 1px solid rgba(255, 255, 255, 0.04);
          border-radius: 16px;
          padding: 16px;
        }

        .ai-section-title {
          font-size: 14px;
          font-weight: 700;
          color: #fff;
          margin: 0 0 6px 0;
        }

        .ai-section-desc {
          font-size: 12px;
          color: rgba(255,255,255,0.45);
          margin: 0;
          line-height: 1.4;
        }

        @keyframes slideLeft {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}

export default LeadsKanban;
